import { auth } from "@canva/user";
import { CONFIG } from "@/config";

const API_BASE = CONFIG.BACKEND_BASE;

export async function canvaFetch(path: string, init: RequestInit = {}) {
  const token = await auth.getCanvaUserToken();
  const headers = new Headers(init.headers || {});
  headers.set("Authorization", `Bearer ${token}`);
  return fetch(`${API_BASE}${path}`, { ...init, headers });
}

export function getApiBase() {
  return API_BASE;
}
